/** Generate a short random unique ID */
export function uid(): string {
  return Math.random().toString(36).slice(2, 9) + Date.now().toString(36);
}

/** Fisher-Yates shuffle — returns a new shuffled array */
export function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** Escape HTML special characters */
export function esc(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Format a date string for display */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleString();
}
